export const LOGIN_USER_START = "LOGIN_USER_START";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";

export const ADMIN_SEARCH_USER_START = "ADMIN_SEARCH_USER_START";
export const ADMIN_SEARCH_USER_SUCCESS = "ADMIN_SEARCH_USER_SUCCESS";
export const ADMIN_SEARCH_USER_FAILURE = "ADMIN_SEARCH_USER_FAILURE";

export const ADMIN_LOAD_ID_START = "ADMIN_LOAD_ID_START";
export const ADMIN_LOAD_ID_SUCCESS = "ADMIN_LOAD_ID_SUCCESS";
export const ADMIN_LOAD_ID_FAILURE = "ADMIN_LOAD_ID_FAILURE";

export const LOAD_ID_START = "LOAD_ID_START";
export const LOAD_ID_SUCCESS = "LOAD_ID_SUCCESS";
export const LOAD_ID_FAILURE = "LOAD_ID_FAILURE";

export const ADD_REFERER = "ADD_REFERER";
export const ADD_AFFILIATE = "ADD_AFFILIATE";
export const CHANGE_DATA = "CHANGE_DATA";
export const CHANGE_STEP = "CHANGE_STEP";
export const REGISTRATION_CONFIRMED = "REGISTRATION_CONFIRMED";
export const REGISTRATION_SAVING = "REGISTRATION_SAVING";
export const REGISTRATION_SAVED = "REGISTRATION_SAVED";
export const REGISTRATION_ERROR = "REGISTRATION_ERROR";
export const SET_AUTHTOKEN = "SET_AUTHTOKEN";
export const USER_SIGNOUT = "USER_SIGNOUT";
export const FETCH_USER_START = "FETCH_USER_START";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const ORDER_TOKEN = "ORDER_TOKEN";
export const ORDER_TOKEN_SAVE = "ORDER_TOKEN_SAVE";
export const ORDER_TOKEN_START = "ORDER_TOKEN_START";
export const ORDER_TOKEN_SUCCESS = "ORDER_TOKEN_SUCCESS";
export const ORDER_TOKEN_FAILURE = "ORDER_TOKEN_FAILURE";

export const REG_EDIT_START = "REG_EDIT_START";
export const REG_EDIT_SUCCESS = "REG_EDIT_SUCCESS";
export const REG_EDIT_FAILURE = "REG_EDIT_FAILURE";

export const SET_SS = "SET_SS";

export const FETCH_CONVERSION_START = "FETCH_CONVERSION_START";
export const FETCH_CONVERSION_SUCCESS = "FETCH_CONVERSION_SUCCESS";
export const FETCH_CONVERSION_FAILURE = "FETCH_CONVERSION_FAILURE";

export const FETCH_ORDERS_START = "FETCH_ORDERS_START";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";

export const SAVE_PAYMENT_START = "SAVE_PAYMENT_START";
export const SAVE_PAYMENT_SUCCESS = "SAVE_PAYMENT_SUCCESS";
export const SAVE_PAYMENT_FAILURE = "SAVE_PAYMENT_FAILURE";

export const REQ_BACKUP_START = "REQ_BACKUP_START";
export const REQ_BACKUP_SUCCESS = "REQ_BACKUP_SUCCESS";
export const REQ_BACKUP_FAILURE = "REQ_BACKUP_FAILURE";
